import { useUserProfile } from "@providers/profile";
import { UserAddress, UserCard } from "@providers/profile/ProfileProvider.model";
import { Sanity } from "@models/sanity.model";
import { GlobalError } from "@components/primitives/input";
import PortableText from "@components/portable-text";
import { StateSchema } from "../address/Address.model";
import Address from "../address";
import CreditCard from "../credit-card";
import { BillingState } from "../subscription/Subscription.model";
import {
  AccountHeader,
  StyledDisclaimer,
  PaymentInfo as StyledPaymentInfo,
} from "../Account.styled";

export interface PaymentInfoProps {
  isDigital: boolean;
  digitalDisclaimer?: Sanity.PortableText;
  states: Array<StateSchema>;
  address: UserAddress;
  card: UserCard;
  dispatchBilling: React.Dispatch<React.SetStateAction<BillingState>>;
}

const PaymentInfo = ({
  isDigital,
  digitalDisclaimer,
  states,
  address,
  card,
  dispatchBilling,
}: PaymentInfoProps) => {
  const {
    profileState: { profile: user },
  } = useUserProfile();

  return (
    <StyledPaymentInfo>
      <AccountHeader>
        <h3>Payment Information</h3>
      </AccountHeader>
      {isDigital && (
        <StyledDisclaimer>
          <PortableText value={digitalDisclaimer} />
        </StyledDisclaimer>
      )}
      {user ? (
        <article>
          <CreditCard
            card={card}
            states={states}
            showAddress={true}
            dispatchBilling={dispatchBilling}
          />
          <Address address={address} dispatchBilling={dispatchBilling} states={states} />
        </article>
      ) : (
        <article>
          <GlobalError>
            Unable to retrieve Payment Information. Please contact customer support.
          </GlobalError>
        </article>
      )}
    </StyledPaymentInfo>
  );
};

export default PaymentInfo;
